import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const projects = [
  {
    title: 'Himalayan Pathways',
    category: 'Web Design',
    image: "/Images/Project1.png",
    link: "https://himalayanpathways.co/"
  },
  {
    title: 'EV Charging',
    category: 'Web Design',
    image: "/Images/Project2.png",
    link: "https://ev-pi.vercel.app/"
  }
];

const WorkSection: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8 bg-white font-sans" data-bg="light">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          className="mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          ref={ref}
        >
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold mb-2 text-gray-900">Selected Works</h2>
              <p className="text-sm text-gray-700">Explore my recent projects</p>
            </div>
            <div>
              <a href="/work" className="group inline-flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
                <span className="underline-animation">View all works</span>
                <span className="transform group-hover:translate-x-1 transition-transform">→</span>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {projects.map((project, index) => (
            <motion.div 
              key={index} 
              className="group relative overflow-hidden rounded-lg"
              variants={itemVariants}
              transition={{ duration: 0.6 }}
            >
              <div className="aspect-w-16 aspect-h-9 relative overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 md:h-96 object-cover object-center transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              
              <div className="p-6 bg-white">
                <div className="mt-4 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-gray-700">
                  <a href={project.link} className="inline-flex items-center space-x-2 text-gray-700 hover:text-gray-900 transition-colors group">
                    <span className="underline-animation">View project</span>
                    <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default WorkSection;